import {Observable} from "rxjs";

export const getTagToAlbumMediaArray = (savedMedia, mediaResults) =>
  (savedMedia && savedMedia.length > 0 ?
    [...mediaResults, ...savedMedia] : mediaResults);

export const calculateTotalBytes = (stagedMedia) => {
  let bytes = 0;
  stagedMedia.filter(s => s.isNew).forEach((media) => {
    if (media.file) {
      bytes += media.file.size;
    } else {
      bytes += 1;
    }
  });
  return bytes;
};

export const calculateSize = (img, maxWidth, maxHeight) => {
  let width = img.width;
  let height = img.height;

  // calculate the width and height, constraining the proportions
  if (width > height) {
    if (width > maxWidth) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width = Math.round((width * maxHeight) / height);
      height = maxHeight;
    }
  }
  return [width, height];
}

export const resizeImage = (file) => {
  return new Observable((observer) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const [newWidth, newHeight] = calculateSize(img, 2000, 2000);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              observer.next(blob); // Emit resized file blob
              observer.complete();
            } else {
              observer.error(new Error("Image resizing failed"));
            }
          },
          'image/jpeg',
          0.8
        );
      };

      img.onerror = (error) => observer.error(error);
    };

    reader.onerror = (error) => observer.error(error);
  });
}
